jQuery(function ($) {
  resizeWindow();

  scrollWindow();

  $(window).resize(resizeWindow);

  $(window).scroll(scrollWindow);

  // MOBILE NAV

  // mobile toggle
  $("#header .mobile_toggle .toggle").on("click tap", function () {
    $("#header .nav.mobile_nav").slideToggle("fast");
  });

  // mobile arrows
  $("#header .nav.mobile_nav li").each(function () {
    if ($(this).find(".dropdown").length < 1) {
      $(this).addClass("noarrow");
    }
  });

  // mobile dropdowns
  $("#header .nav.mobile_nav li a.has_children").on("click tap", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).parent("li").toggleClass("open");
    $(this).parent("li").find(".dropdown").slideToggle("fast");
  });

  // mobile close
  $("#header .nav.mobile_nav .signin .close").on("click tap", function () {
    $("#header .nav.mobile_nav").slideToggle("fast");
  });

  // NEW (winter 22-23)
  function showMobileSearch() {
    // search
    $("#header .mobile_search").addClass('is-active');
    setTimeout(function() {
      $("#header .mobile_search").addClass('is-visible')
      $("#MobileSearchInput").focus();
    }, 10);

    // overlay
    $("#overlayUnderHeader").addClass('is-active');
    setTimeout(function() {
      $("#overlayUnderHeader").addClass('is-visible');
    }, 10);
  }

  function hideMobileSearch() {
    // search
    $("#header .mobile_search").removeClass('is-visible');
    setTimeout(function() {
      $("#header .mobile_search").removeClass('is-active')
      $("#header .toggle_search").focus();
    }, 250);

    // overlay
    $("#overlayUnderHeader").removeClass('is-visible');
    setTimeout(function() {
      $("#overlayUnderHeader").removeClass('is-active');
    }, 250);
  }

  // toggle mobile search
  $("#header .search .toggle_search").on("click tap", function () {
    if (!$("#header .mobile_search").hasClass('is-active')) {
      showMobileSearch();
    } else {
      hideMobileSearch();
    }
  });

  $("#overlayUnderHeader").on("click tap", function () {
    hideMobileSearch();
  });

  // NEW (winter 22-23)
  // close mobile search
  $(".js-mobile-search-close").on("click tap", function () {
    hideMobileSearch();
  });

  // footer nav
  $(document).on("click tap", "#footer .nav.mobile_nav h4.toggle", function () {
    $(this).next(".inner").slideToggle();
  });

  //////////////

  // DESKTOP ONLY

  // back to top
  $("#back_to_top").on("click tap", function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
  });

  //////////////

  // pretty dropdowns
  if ($("#SortBy").length) {
    $("#SortBy").niceSelect();
  }

  // product fullscreen open
  $(".product-single .images .main span").on("click tap", function () {
    $("html,body").css("overflow", "hidden");
    $("#fullscreen").fadeIn(300);
  });

  // product fullscreen close
  $("#fullscreen .close").on("click tap", function () {
    $("html,body").css("overflow", "auto");
    $("#fullscreen").fadeOut(300);
  });

  // product thumbs
  $(".product-single .images .thumbs .thumb").on("click tap", function () {
    $(".product-single .images .thumbs .thumb.active").removeClass("active");
    $(this).addClass("active");
    const imageId = $(this).data('image-id')
    $(".product-single .images.desktop .main-img").removeClass('active');

    $(`.product-single .images.desktop .main-img[data-image-id="${imageId}"]`).addClass('active');
  });


  $(".product-single .images .product-mobile-image-thumb").on("click tap", function () {
    $(".product-single .images .product-mobile-image-thumb.active").removeClass("active");
    $(this).addClass("active");
    const imageId = $(this).data('image-id')

    $(".product-single .images.mobile .main-img").removeClass('active');
    $(`.product-single .images.mobile .main-img[data-image-id="${imageId}"]`).addClass('active');
  });

  // product accordions
  $(".product-single .accordion .title").on("click tap", function () {
    $(this).toggleClass("open");
    $(this).next(".text").slideToggle("fast");
  });

  // number input arrows
  $(".number-btns .inc").on("click tap", function () {
    var rel = $(this).attr("rel");
    var oldValue = $(rel).val();
    var newVal = parseFloat(oldValue) + 1;
    $(rel).val(newVal);
    $(rel)[0].dispatchEvent(new Event('change'));
  });
  $(".number-btns .dec").on("click tap", function () {
    var rel = $(this).attr("rel");
    var oldValue = $(rel).val();
    if (oldValue > 0) {
      var newVal = parseFloat(oldValue) - 1;
    } else {
      newVal = 0;
    }
    $(rel).val(newVal);
    $(rel)[0].dispatchEvent(new Event('change'));
  });
});

function resizeWindow() {
  var ww = $(window).width();
  var wh = $(window).height();
  var hh = $("#header").outerHeight();

  if (ww > 768) {
    $("#header .nav.mobile_nav").hide(0);
  }

  if (ww > 768) {
    $("#footer .nav").removeClass("mobile_nav");
  } else {
    $("#footer .nav").addClass("mobile_nav");
  }

  if ($("#promo").length) {
    var ph = $("#promo").outerHeight();
    var navHeight = wh - hh - ph;

    $("#header .nav.mobile_nav").css("max-height", navHeight + "px");
  } else {
    var navHeight = wh - hh;

    $("#header .nav.mobile_nav").css("max-height", navHeight + "px");
  }
}

function scrollWindow() {
  var scrolltop = $(window).scrollTop();
  var scrollpos = $(this).scrollTop();
  var ww = $(window).width();

  if (ww > 768) {
    if (scrolltop > 500) {
      $("#back_to_top").fadeIn(300);
    } else {
      $("#back_to_top").fadeOut(300);
    }
  }
}

var myLazyLoad = new LazyLoad({
  elements_selector: ".lazy",
});

$(function () {
  $(".gift-note input[type=checkbox]").on("click tap", function () {
    $(".gift-note-input").toggle();
  });
  /*
    $('.gift-note textarea').on('keyup',function() {
      $('.gift-note-count').text(($(this).val().length));
    });
    */
});

// Returns products state
/*
const getProduct = async (handle) => {
  return await fetch(`/products/${handle}?view=lowestprice`, {
    credentials: "same-origin",
  })
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.text();
    })
    .then(function (html) {
      // Initialize the DOM parser
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      // console.log(doc.querySelector('body').innerHTML);
      return doc.querySelector("body").innerHTML;
    })
    .then(function (res) {
      return res;
    })
    .catch((error) => {
      console.error(error);
    });
};
const element = document.querySelectorAll(".js-lowest-price");

element.forEach((el) => {
  const productHandle = el.getAttribute("data-lowest-price");
  getProduct(productHandle).then(function (res) {
    el.innerHTML = res;
  });
});
*/

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  document.body.setAttribute('dropdown-opened', false);
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  document.body.setAttribute('dropdown-opened', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    document.body.setAttribute('dropdown-opened', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);
